var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.509,
    height: 17.867,
    fill: "none",
    viewBox: "0 0 17.509 17.867",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.509 9.1364c0-0.63343-0.0569-1.2425-0.1625-1.8272h-8.4135v3.4556h4.8077c-0.2071 1.1167-0.8365 2.0628-1.7826 2.6963v2.2414h2.8871c1.6892-1.5552 2.6638-3.8454 2.6638-6.566z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.9333 17.867c2.412 0 4.4342-0.7999 5.9123-2.1643l-2.8871-2.2414c-0.8 0.536-1.8232 0.8527-3.0252 0.8527-2.3267 0-4.2961-1.5715-4.9986-3.683h-2.9846v2.3146c1.4699 2.9195 4.491 4.9214 7.9832 4.9214z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9347 10.631c-0.17867-0.536-0.28018-1.1086-0.28018-1.6974 0-0.58877 0.10151-1.1613 0.28018-1.6973v-2.3146h-2.9846c-0.60503 1.206-0.95018 2.5704-0.95018 4.0119 0 1.4415 0.34515 2.8059 0.95018 4.0119z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.9333 3.553c1.3116 0 2.4892 0.45073 3.415 1.3359l2.5622-2.5622c-1.547-1.4415-3.5692-2.3267-5.9772-2.3267-3.4921 0-6.5132 2.0019-7.9832 4.9215l2.9846 2.3145c0.70248-2.1115 2.6719-3.683 4.9986-3.683z",
    fill: "#ea4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3fd11b58e5cb6fcb9128f2875132580a.svg";
export { ForwardRef as ReactComponent };